import axios from 'axios';
import { getErent2MgmtUrl } from '@utils/env';
import { getTokenHeader } from '@utils/api';

const mgmtApi = () =>
  axios.create({
    baseURL: getErent2MgmtUrl(),
    headers: { 'Content-Type': 'application/json' },
  });

const authHeader = () => ({ 'x-token': getTokenHeader() });

export const serializeParams = (params) =>
  Object.keys(params)
    .reduce((pairs, key) => {
      const values = Array.isArray(params[key]) ? params[key] : [params[key]];
      return pairs.concat(values.map((value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`));
    }, [])
    .join('&');

export const cleanCustomFields = (values = {}) =>
  Object.keys(values).reduce((clean, key) => {
    const value = values[key];
    if (value !== '' && (!Array.isArray(value) || value.length)) clean[key] = value;
    return clean;
  }, {});

export const customFieldParams = (values = {}) =>
  Object.keys(cleanCustomFields(values)).reduce((params, key) => {
    params[`cf[${key}]`] = values[key];
    return params;
  }, {});

export const customFieldDisplayValue = (value) => value || '—';

export const validateFieldDef = ({ key, label, type, options }) => {
  if (!label.trim() || label.length > 100) return '名稱必須為 1–100 個字元';
  if (!/^[a-z0-9-]{1,40}$/.test(key)) return '鍵值只可包含小寫英文字母、數字及連字號（最多 40 個字元）';
  if (type !== 'text') {
    const clean = options.map((option) => option.trim());
    if (!clean.length || clean.length > 50 || clean.some((option) => !option || option.length > 100))
      return '選項必須有 1–50 個非空白值，每項最多 100 個字元';
    if (new Set(clean).size !== clean.length) return '選項不可重複';
  }
  return '';
};

export const listRecords = (params = {}) =>
  mgmtApi()
    .get('/records', { headers: authHeader(), params, paramsSerializer: serializeParams })
    .then((res) => res.data);

export const getRecord = (id) =>
  mgmtApi()
    .get(`/records/${id}`, { headers: authHeader() })
    .then((res) => res.data);

export const updateRecord = (id, body) =>
  mgmtApi()
    .put(`/records/${id}`, body, { headers: authHeader() })
    .then((res) => res.data);

export const deleteRecord = (id) =>
  mgmtApi()
    .delete(`/records/${id}`, { headers: authHeader() })
    .then((res) => res.data);

export const listCustomFieldDefs = () =>
  mgmtApi().get('/custom-field-defs', { headers: authHeader() }).then((res) => res.data);

export const createCustomFieldDef = (body) =>
  mgmtApi().post('/custom-field-defs', body, { headers: authHeader() }).then((res) => res.data);

export const updateCustomFieldDef = (id, body) =>
  mgmtApi().put(`/custom-field-defs/${id}`, body, { headers: authHeader() }).then((res) => res.data);

export const deleteCustomFieldDef = (id) =>
  mgmtApi().delete(`/custom-field-defs/${id}`, { headers: authHeader() }).then((res) => res.data);
